import nl from './nl'

// Simple translation hook
// In Phase 3 replace with i18next for full internationalisation
export const useTranslation = () => {
  const t = (key) => {
    return nl[key] || key
  }
  return { t }
}